import { ReactNode } from 'react'
import { Actions } from './actions'
import { Body } from './body'
import { PublicImg } from './publicImg'
import * as css from './styles'
import { Title } from './title'
import { CallToAction } from './types'

interface Props {
  text: {
    title?: string
    subtitle?: string
    body?: React.ComponentProps<typeof Body>
  }
  callToActionBtns?: CallToAction[]
  imageFileName?: string
  svg?: ReactNode
}

export const NoData = ({ text, callToActionBtns = [], imageFileName, svg = null }: Props) => {
  const alt = text?.title || text.body?.mainText || ''

  return (
    <css.MotionContainer data-testid="no-data">
      {svg ? <div style={{ marginBottom: 24 }}>{svg}</div> : null}
      {imageFileName && <PublicImg alt={alt} fileName={imageFileName} />}
      {text?.title && <Title title={text.title} />}
      {text?.subtitle && <Title title={text.subtitle} />}
      {text.body ? <Body {...text.body} /> : null}
      <Actions callToActionBtns={callToActionBtns} />
    </css.MotionContainer>
  )
}
